import { computed } from 'vue'
import { useAuth0 } from '@auth0/auth0-vue'
import { analyticsEvent } from '@/utils/analytics'

export function useAuth() {
  const {
    isAuthenticated,
    isLoading,
    user,
    loginWithPopup,
    logout,
    getAccessTokenSilently
  } = useAuth0()


  const login = async ({returnTo = '', partnerId = ''}) => {
    // const target = partnerId ? `/${partnerId}` : ''
    const params = window.location.origin.includes('localhost') ?  
      {authorizationParams: {redirect_uri: window.location.origin}} 
      : 
      {}

    try {
      await loginWithPopup(params)
      analyticsEvent("login", "authentication", "login")
    } catch (e) {
      if (e.message === 'Popup closed') {
        console.log('Login cancelled by user')
      } else {
        console.error('Login error', e)
      }
    }
  }

  const logoutUser = async ({partnerId = ''}) => {
    const target = partnerId ? `/${partnerId}` : ''
    try {
      await logout({
        logoutParams: {
          returnTo: window.location.origin + target
        }
      })
      analyticsEvent("logout", "authentication", "logout")
    } catch (error) {
      console.error('Logout error', error)
    }
  }

  const getToken = async () => {
    try {
      return await getAccessTokenSilently()
    } catch (error) {
      console.error('Error getting access token:', error)
      return null
    }
  }

  return {
    isAuthenticated: computed(() => isAuthenticated.value),
    isLoading: computed(() => isLoading.value),
    user: computed(() => user.value),
    login,
    logout: logoutUser,
    getToken
  }
}